import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatcher } from '@angular/router';

import { LoginContainerComponent } from './containers/login-container/login-container.component';
import { LogoutContainerComponent } from './containers/logout-container/logout-container.component';
import { OauthRedirectContainerComponent } from './containers/oauth-redirect/oauth-redirect-container.component';
import { UseOauthGuard } from './guards/use-oauth.guard';
import { LoginRouteMatcher, LogoutRouteMatcher } from './matchers/route-matchers';

const routes: Routes = [
    {
        matcher: LoginRouteMatcher as UrlMatcher,
        canActivate: [UseOauthGuard],
        component: LoginContainerComponent
    },
    {
        matcher: LogoutRouteMatcher as UrlMatcher,
        component: LogoutContainerComponent
    },
    {
        path: 'redirect',
        component: OauthRedirectContainerComponent
    },
    {
        path: '**',
        redirectTo: '../login'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthenticationRoutingModule {}
